export const stringCompare =
    (a: string, b: string): boolean => a?.toUpperCase().trim() === b?.toUpperCase().trim();

// https://stackoverflow.com/a/34749873
export const isObject = (item: any) => {
    return (item && typeof item === 'object' && !Array.isArray(item));
};

// tslint:disable-next-line
type mergable = { [key: string]: mergable };
export const deepMerge = (target: mergable, ...sources: mergable[]): mergable => {
    if (!sources.length) {
        return target;
    }
    const source = sources.shift();

    if (isObject(target) && isObject(source)) {
        for (const key in source) {
            if (isObject(source[key])) {
                if (!target[key]) {
                    Object.assign(target, {
                        [key]: ({})
                    });
                }
                deepMerge(target[key], source[key]);
            }
            else {
                Object.assign(target, {
                    [key]: source[key]
                });
            }
        }
    }
    return deepMerge(target, ...sources);
};
